module.exports = __webpack_public_path__ + "img/chrity_1.e4a6eada.png";